/**
 * Ryan O'Dowd
 * 2022-08-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';
import {
  useNetInfo,
} from '@react-native-community/netinfo';

const OfflineBanner = (props: OfflineBannerProps) => {
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const netInfo = useNetInfo();

  if (netInfo.isInternetReachable !== false) { // @NOTE: true and null are both valid
    return null;
  }

  return (
    <View style={[styles.container, props.containerStyle]}>
      <Text style={[styles.text, props.textStyle]}>{i18n('noInternet', props.message)}</Text>
    </View>
  );
};

class OfflineBannerProps {
  message?: string;
  containerStyle?: any;
  textStyle?: any;
};

export default OfflineBanner;
